import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';

export const CustomerPasswordValidation = yup.object().shape({
    currentPassword: yup.string().required(ERRORS.required),
    newPassword: yup
        .string()
        .required(ERRORS.required)
        .min(8)
        .max(40)
        .notOneOf([yup.ref('currentPassword')], 'Cannot be the same as current password'),
    confirmNewPassword: yup
        .string()
        .oneOf([yup.ref('newPassword')], "Passwords don't match!")
        .required(ERRORS.required),
});
